import { Component, OnInit } from '@angular/core';
import { CompanyDataService } from '../company-data.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UserDataService } from '../../../../modules/auth/user-data.service';
import { Options } from 'select2';
import { NgForm } from '@angular/forms';
import { SelectFieldsTable } from '../../../../modules/jobs/create-job/select-fields.table';

import { BreadcrumbService } from 'ng-breadcrumb';

@Component({
    selector: 'app-company-profile',
    templateUrl: './company-profile.component.html',
    styleUrls: ['./company-profile.component.scss'],
    providers: [SelectFieldsTable]
})
export class CompanyProfileComponent implements OnInit {

    // Review Form ------- START
    isLoggedIn = false;
    reviewData: object;
    reviewNumbers: any = {};
    // Rating
    currentRate = 3;
    // Select 2 Inputs Options
    public singleOption: Options;
    // Select Fields Input
    departments: Array<string> = [];
    hideName: boolean
    // Server Response After Send
    serverResp = false;
    formHasBeenSend = false;
    formSuccessfulSend = false;
    serverErrorMessages = [];
    // Review Form --------- END

    fullNameFail: boolean;
    reviewTitleFail : boolean;

    companyData: any = [];
    jobs: any = [];
    fullUser: any;
    userId: any;
    isCandidate: boolean;
    companyLogoPath: string;
    userObject: any = [];

    companyFacebook: string;
    companyInstagram: string;
    companyLinkedIn: string;
    companyTikTok: string;
    companyYouTube: string;
    companyWebsite: string;

    companyId: string;
    isAuthor: boolean;

    userAlreadyReview = false;

    reviews;

    constructor(private companyDataService: CompanyDataService,
        private route: ActivatedRoute,
        private breadcrumbService: BreadcrumbService,
        private router: Router,
        private selectFields: SelectFieldsTable,
        
        private userInfo: UserDataService) {
    }


    ngOnInit() {
        
        this.departments = this.selectFields.departments;
        this.route.params.subscribe(params => {
            if (params['id'] === undefined) {
                // Get data about current user company

                if (this.userInfo.isLoggedIn === false) {
                    this.router.navigate(['/']);
                }

                this.companyDataService.getCurrentUserCompany().subscribe((resData: any) => {
                    if (resData == null) {
                        this.router.navigate(['/adauga-companie/']);
                    } else {
                        this.companyData = resData;
                        this.companyId = this.companyData.id;
                        this.breadcrumbService.addFriendlyNameForRoute('/compania-mea', resData.companyName);
                        this.isAuthor = true;
                        this.companyLogoPath = this.companyData.companyLogo.link;

                        this.companyFacebook = this.companyData.companySocialMedia['companyFacebook'];
                        this.companyInstagram = this.companyData.companySocialMedia['companyInstagram'];
                        this.companyLinkedIn = this.companyData.companySocialMedia['companyLinkedIn'];
                        this.companyTikTok = this.companyData.companySocialMedia['companyTikTok'];
                        this.companyYouTube = this.companyData.companySocialMedia['companyYouTube'];
                        this.companyWebsite = this.companyData.companySocialMedia['companyWebsite'];

                        // Get all jobs from company
                        this.companyDataService.getJobsFromCompanyId(this.companyId).subscribe(jobs => {
                            this.jobs = jobs;
                        }, error => {
                        });
                    }
                }, error => {
                });
            } else {
                this.companyId = params['id'];

                console.log("id-ul companiei", this.companyId);
                // Check if company is current user company
                this.companyDataService.getCurrentUserCompany().subscribe(res => {
                    if (this.companyId === res['id']) {
                        this.isAuthor = true;
                    }
                })

                // Get data about company
                this.companyDataService.getCompanyData(this.companyId).subscribe((resData: any) => {
                    if (resData === null) {
                        this.router.navigate(['/404']);
                    }
                    console.log("Company Data");
                    console.log(resData);
                    this.companyData = resData;
                    this.breadcrumbService.addFriendlyNameForRouteRegex('/companii/[a-zA-Z0-9]', resData.companyName);
                    this.companyLogoPath = this.companyData.companyLogo.link;

                    this.companyFacebook = this.companyData.companySocialMedia['companyFacebook'];
                    this.companyInstagram = this.companyData.companySocialMedia['companyInstagram'];
                    this.companyLinkedIn = this.companyData.companySocialMedia['companyLinkedIn'];
                    this.companyTikTok = this.companyData.companySocialMedia['companyTikTok'];
                    this.companyYouTube = this.companyData.companySocialMedia['companyYouTube'];
                    this.companyWebsite = this.companyData.companySocialMedia['companyWebsite'];
                }, error => {
                });

                // Get all jobs from company
                this.companyDataService.getJobsFromCompanyId(this.companyId).subscribe(jobs => {
                    this.jobs = jobs;
                }, error => {
                });
            }


            // Get Review Numbers
            this.companyDataService.getReviewNumbers(this.companyId).subscribe(revNumber => {
                this.reviewNumbers = revNumber;
            })

            // Check if the user already reviewed
            this.companyDataService.alreadyReviewed(this.companyId).subscribe(res => {
                this.userAlreadyReview = res === true;
            })

            // Get reviews
            this.companyDataService.getReviewsOfCompany(this.companyId).subscribe(result => {
                this.reviews = result;
                console.log(this.reviews);
            })

            // User Data Service
            this.userInfo.getMainData().subscribe(user => {
                // Store All User Data
                this.fullUser = user;
                // User ID
                this.userId = this.fullUser.userId;
                this.isLoggedIn = true;
                this.isCandidate = this.fullUser.roles.includes('ROLE_JobBoardsCandidate');
            }, error => {
                // Make User ID empty if is not logged in
                this.userId = '';
                this.isLoggedIn = false;
            });
        })


        // Select 2 Options - Review Form
        this.singleOption = {
            width: '100%',
            placeholder: ' -- Selecteaza optiune -- ',
            allowClear: true
        };


        this.breadcrumbService.addFriendlyNameForRoute('/companii', 'Lista companii')
    }

    letterCheck(name, value) {
        console.log(name)
        if(name === 'name'){
            if (!(/^[a-zăîșțâA-ZĂÎȘȚÂ\s\-\']*$/.test(value))) {
                this.fullNameFail = true;
            } else {
                this.fullNameFail = false;
            }
        }
        if(name === 'reviewTitle'){
            if (!(/^[a-zăîșțâA-ZĂÎȘȚÂ\s\-\']*$/.test(value))) {
                this.reviewTitleFail = true;
            } else {
                this.reviewTitleFail = false;
            }
        }
    }


    // Review Form Submit
    onReviewJob(jobForm: NgForm) {

        if(this.fullNameFail || this.reviewTitleFail){
            return;
        }

        this.reviewData = {
            userId: this.userId,
            companyId: this.companyData.id,
            reviewTitle: jobForm.value.reviewTitle,
            rating: this.currentRate,
            experienceLevel: jobForm.value.experienceLevel,
            userName: jobForm.value.name,
            proReview: jobForm.value.proReview,
            contraReview: jobForm.value.contraReview,
            department: jobForm.value.department,
            salary: jobForm.value.salary,
        }

        this.companyDataService.postCompanyReview(this.reviewData).subscribe(responseData => {

            // Error Messages Input
            this.serverResp = true;
            this.formHasBeenSend = true;
            this.formSuccessfulSend = true;

            window.scroll({
                top: 1300,
                behavior: 'smooth'
            });

        }, error => {

            if (error.error.reason === 'alreadyReviewed') {
                this.serverResp = false;
                this.formHasBeenSend = true;
                this.serverErrorMessages.push('Ati evaluat deja aceasta companie.')
                window.scroll({
                    top: 1300,
                    behavior: 'smooth'
                });
            }
        })
    }
}
